import { useState } from "react";

export default function PasswordField({
  id,
  label = "Password",
  value,
  onChange,
  placeholder,
  autoComplete,
  minLength,
  hint,
  labelAside = null,
}) {
  const [visible, setVisible] = useState(false);

  return (
    <div className="ui-field">
      <div className="auth-row">
        <label className="ui-label" htmlFor={id}>{label}</label>
        {labelAside}
      </div>

      <div className="auth-pw">
        <input
          id={id}
          className="ui-input"
          type={visible ? "text" : "password"}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          autoComplete={autoComplete}
          minLength={minLength}
          required
        />
        <button
          type="button"
          className="auth-toggle"
          onClick={() => setVisible((v) => !v)}
          aria-label={visible ? "Hide password" : "Show password"}
        >
          {visible ? "Hide" : "Show"}
        </button>
      </div>

      {hint && <p className="ui-hint">{hint}</p>}
    </div>
  );
}